export const descriptionMaxLength = 4000;
